// extracted by mini-css-extract-plugin
export var backdropBlur = "_jy-0";
export var contentCard = "_jy-5";
export var frame = "_jy-2";
export var image = "_jy-4";
export var imagePane = "_jy-3";
export var modal = "_jy-1";